/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Supporter } from './Supporter';
import {
    SupporterFromJSON,
    SupporterFromJSONTyped,
    SupporterToJSON,
} from './Supporter';

/**
 * 
 * @export
 * @interface GetSupporters
 */
export interface GetSupporters {
    /**
     * 
     * @type {Array<Supporter>}
     * @memberof GetSupporters
     */
    data?: Array<Supporter>;
}

/**
 * Check if a given object implements the GetSupporters interface.
 */
export function instanceOfGetSupporters(value: object): value is GetSupporters {
    let isInstance = true;

    return isInstance;
}

export function GetSupportersFromJSON(json: any): GetSupporters {
    return GetSupportersFromJSONTyped(json, false);
}

export function GetSupportersFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSupporters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(SupporterFromJSON)),
    };
}

export function GetSupportersToJSON(value?: GetSupporters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(SupporterToJSON)),
    };
}

